
import { NDescriptions, NDescriptionsItem } from 'naive-ui';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

import ComponentBase from '~/components/component-base';
import DeviceStatusDisplay from '~/components/device-status-display/device-status-display.vue';
import StationEventsTimeline from '~/components/station-events-timeline/station-events-timeline.vue';


import { useStationDetailStore } from '~/store/station-details.store';

const NetworkMapping: {[ hardware: string ]: string } = {
    'ELAV-LTEM-UL': 'LTE-M',
    'ELAV-LTEM-EN': 'LTE-M',
    'ELAV-L868-EN': 'LoRaWan',
    'ELAV-L868-UL': 'LoRaWan',
    'ELAV-L915-EN': 'LoRaWan',
    'ELAV-L915-UL': 'LoRaWan',
}

export default defineComponent({

    extends: ComponentBase,

    components: {
        NDescriptions,
        NDescriptionsItem,

        DeviceStatusDisplay,
        StationEventsTimeline,
    },

    computed: {
         ...mapState(useStationDetailStore, ['station', 'since','before', 'measures', 'events']),

        networkType(): string {
            return this.station?.hardware ? NetworkMapping[this.station.hardware] : null;
        },

    }
});